import { List } from 'echarts'
import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/Project'

const ProjectInfo = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  List(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/List`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  },
  Release(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Release`,
      data
    })
  },
  SetIsPublic(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetIsPublic`,
      data
    })
  },
  SetProjectStatus(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetProjectStatus`,
      data
    })
  }
}

export default ProjectInfo
